import { useBox } from "@react-three/cannon";
import { WALL_DIMENSIONS } from "../lib/consts";

export default function Wall({
	position,
	rotation,
}: {
	position: [number, number, number];
	rotation?: [number, number, number];
}) {
	const [ref] = useBox(() => ({
		args: WALL_DIMENSIONS,
		position,
		rotation,
		type: "Static",
	}));

	return (
		<mesh
			ref={ref}
			position={position}
			rotation={rotation}
			receiveShadow
		>
			<boxGeometry args={WALL_DIMENSIONS} />
			<meshStandardMaterial color="#ffbfa1" roughness={0.9} />
		</mesh>
	);
}
